import { ICrudGenericFields } from 'models/CrudInterface'

export const pricesListsMassiveUpdateListFormFields: Array<ICrudGenericFields> =
	[
		{
			id: 'lk_list',
			type: 'text',
			labelWidth: 'col-sm-4',
			width: 'col-sm-10',
			height: 'col-sm-12',
			default: null,
			maxChars: 20,
			autoComplete: 'new-off',
			disabled: true,
			comboData: '',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'lk_sel_list',
			type: 'combo',
			labelWidth: 'col-sm-4',
			width: 'col-sm-8',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: false,
			comboData: 'selectionType',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'lk_clie',
			type: 'autoComplete',
			labelWidth: 'col-sm-4',
			width: 'col-sm-8',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: true,
			comboData: '',
			dependsOn: {
				id: 'lk_sel_list',
				values: [
					{
						idValue: '2',
						disabled: false
					}
				]
			}
		},
		{
			id: 'lk_clie_id',
			type: 'text',
			labelWidth: '',
			width: '',
			height: '',
			default: null,
			maxChars: 0,
			autoComplete: 'new-off',
			disabled: true,
			comboData: '',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'lk_prod_lp',
			type: 'autoComplete',
			labelWidth: 'col-sm-4',
			width: 'col-sm-8',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: true,
			comboData: '',
			dependsOn: {
				id: 'lk_sel_list',
				values: [
					{
						idValue: '3',
						disabled: false
					}
				]
			}
		},
		{
			id: 'lk_prod_lp_id',
			type: 'text',
			labelWidth: '',
			width: '',
			height: '',
			default: null,
			maxChars: 0,
			autoComplete: 'new-off',
			disabled: true,
			comboData: '',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'desc_rec',
			type: 'combo',
			labelWidth: 'col-sm-4',
			width: 'col-sm-8',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: true,
			comboData: 'operationType',
			dependsOn: {
				id: 'lk_sel_list',
				values: [
					{
						idValue: '3',
						disabled: false
					}
				]
			}
		},
		{
			id: 'pc_min',
			type: 'text',
			labelWidth: 'col-sm-4',
			width: 'col-sm-8',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: true,
			comboData: '',
			dependsOn: {
				id: 'lk_sel_list',
				values: [
					{
						idValue: '3',
						disabled: false
					}
				]
			}
		},
		{
			id: 'pc_max',
			type: 'text',
			labelWidth: 'col-sm-4',
			width: 'col-sm-8',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: true,
			comboData: '',
			dependsOn: {
				id: 'lk_sel_list',
				values: [
					{
						idValue: '3',
						disabled: false
					}
				]
			}
		},
		{
			id: 'lista_cliente',
			type: 'text',
			labelWidth: 'col-sm-4',
			width: 'col-sm-8',
			height: 'col-sm-12',
			default: null,
			maxChars: 20,
			autoComplete: 'new-off',
			disabled: true,
			comboData: '',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		}
	]
